import { siteConfig } from "../config/site";

export type EventName = "booking_click" | "phone_click" | "email_click";

export const hasAnalyticsConsent = () => {
  try {
    const raw = localStorage.getItem("kp-cookie-consent");
    return raw ? Boolean(JSON.parse(raw).analytics) : false;
  } catch {
    return false;
  }
};

// Sends event to backend (anonymous) and to window.dataLayer if analytics consent exists.
export const track = (event: EventName, extra: Record<string, unknown> = {}) => {
  const payload = { path: window.location.pathname, ...extra };
  const base = process.env.REACT_APP_BACKEND_URL;
  if (base) {
    fetch(`${base}/api/events/${event}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => undefined);
  }
  if (hasAnalyticsConsent()) {
    const w = window as unknown as { dataLayer?: unknown[] };
    w.dataLayer = w.dataLayer || [];
    w.dataLayer.push({ event, site: siteConfig.name, ...payload });
  }
};
